export default __webpack_public_path__ + "static/media/refacturar-pg.4095aebc.png";